import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { useStore } from 'effector-react'
import { APP_URL } from '~/shared/config/env'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { Title, Wrapper } from './styled'

type CardProps = {
  id: UniqueId
  name: string
  isManualRegistration?: boolean
}

export function Card({ id, name, isManualRegistration = false }: CardProps) {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const defaultToPage = featureFlags.simplified_registration
    ? 'simplified-registration'
    : 'registration'

  const toPage = isManualRegistration ? 'registration-manual' : defaultToPage

  const platform = Capacitor.getPlatform()
  const isSimplifiedOnNative =
    platform !== 'web' && toPage === 'simplified-registration'

  const handleClick = async (e: React.MouseEvent) => {
    if (isSimplifiedOnNative) {
      e.preventDefault()
      await Browser.open({
        url: `${APP_URL}/simplified-registration?taxiparkId=${id}&from=${platform}`,
      })
    }
  }

  return (
    <Wrapper to={`/${toPage}?taxiparkId=${id}`} onClick={handleClick}>
      <Title>{name}</Title>
    </Wrapper>
  )
}
